import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// D3: «50+ исполнителей» — число считается на бэкенде с округлением вниз, поэтому формулировка остаётся истинной
export const ExecutorsProofBadge = ({ dark = false, className = "" }) => {
  const [label, setLabel] = useState(null);
  useEffect(() => {
    axios.get(`${API}/public/platform-stats`).then((r) => setLabel(r.data?.executors_display || null)).catch(() => {});
  }, []);
  if (!label) return null;
  return (
    <div data-testid="executors-proof-badge" className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-medium ${className}`}
      style={dark ? { background: "rgba(255,255,255,0.08)", color: "#fff", border: "1px solid rgba(255,255,255,0.18)" }
        : { background: "#F0FDFA", color: "#134E4A", border: "1px solid #99F6E4" }}>
      <Users size={15} /> <span data-testid="executors-proof-value">{label}</span> исполнителей в Краснодаре
    </div>
  );
};
